import { render, staticRenderFns } from "./EstadisticaVenta.vue?vue&type=template&id=1195cd55&scoped=true"
import script from "./EstadisticaVenta.vue?vue&type=script&lang=js"
export * from "./EstadisticaVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1195cd55",
  null
  
)

export default component.exports